<header class="header"></header>
  <div class="container-gray isBackgoround">
    <main>
      <div class="v-application v-application--is-ltr theme--light main">
        <form
          style="
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          "
        >
          <h1 class="mb-10 h3">パスワードの再設定</h1>
          <p
            style="
              font-family: Noto Sans JP;
              font-size: 16px;
              font-weight: 400;
              line-height: 29px;
              letter-spacing: 0em;
              text-align: center;
              margin-bottom: 24px;
            "
          >
            パスワード再設定用ＵＲＬを記載したメールをお送りします。<br />
            下記に登録したメールアドレスを入力してください。
          </p>
          <div
              class="mb-10 v-card v-sheet theme--light elevation-0"
              style="
                width: 410px;
                background-color: var(--color-100-bold);
                border-color: var(--color-100-bold);
              "
            >
              <div class="v-card__title text-caption">
                <div style="padding: 10px">
                  <p
                    class="text-subtitle-1 d-flex align-center mb-2"
                    style="height: 28px; display: flex; justify-content: center"
                  >
                    <!-- <i
                      id="icon-question"
                      aria-hidden="true"
                      class="v-icon notranslate v-icon--left mdi mdi-help-circle theme--right"
                    ></i> -->
                    <span class="v-text-font-14">認証情報は以下のシステムで共通となります。</span>
                  </p>
                  <p class="bold-14">
                    <img src="/assets/collabo-portal/images/check_small.svg" style="margin: 10px;" alt="登録支援システム" height="16">登録支援システム<br>
                    <img src="/assets/collabo-portal/images/check_small.svg" style="margin: 10px;" alt="処方元情報連携システム" height="16">処方元情報連携システム<br>
                    <img src="/assets/collabo-portal/images/check_small.svg" style="margin: 10px;" alt="症例情報連携システム" height="16">症例情報連携システム<br>
                  </p>
                </div>
              </div>
            </div>
          <div
            class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
            style="display: flex; justify-content: center; width: 550px; max-width: 90vw"
          >
            <div class="v-input__control common_input">
              <div style="display: flex; align-items: center">
                <label
                  for="input-13"
                  class="bold"
                  style="height: 29px; margin-right: 12px"
                  >メールアドレス</label
                >
                <app-required-label></app-required-label>
              </div>
              <div class="v-input__slot">
                <input
                  (focus)="focus(inputState.email)"
                  (blur)="blur(inputState.email)"
                  id="input-13"
                  name="input-13"
                  type="email"
                  [(ngModel)]="email"
                />
              </div>
              <div class="v-text-field__details">
                <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
                <div class="v-messages theme--light error--text">
                  <div
                    *ngIf="errorMessages.forgetpassword.email"
                    class="v-messages__wrapper"
                  >
                    {{ errorMessages.forgetpassword.email }}

                    <!-- 注釈及びエラーテキストが入ります。 -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- TODO アプリレイアウト -->
          <div class="text-center mb-6" style="width: 550px; max-width: 90vw">
            <button
              type="button"
              class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary primary-button"
              style="width: 100%"
              medium=""
              (click)="changePassword()"
            >
              <span class="v-btn__content bold"> 送信 </span>
            </button>
          </div>
        </form>
      </div>
    </main>
  </div>